<template>
  <el-card style="width: 100%">
    <div
      slot="header"
      class="clearfix"
    >
      <span>Beszállítás napokra</span>
    </div>
    <div class="filter-container">
      <el-form
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="16" style="display: flex; ">
            <el-form-item
              label="Dátum"
            >
              <el-date-picker
                v-model="dateRange"
                type="daterange"
                :clearable="false"
                format="yyyy. MM. dd."
                value-format="yyyy-MM-dd"
                :picker-options="dateRangeOptions"
                style="margin-right: 10px;"
                @change="handleChange"
              />
            </el-form-item>
            <el-form-item style="margin-right: 10px;"
                          label="Beszállító"
            >
              <el-select
                v-model="supplier"
                filterable
                remote
                :remote-method="searchPartner"
                :loading="partnerLoading"
                placeholder="Gépelj a kereséshez..."
                style="width: 100%;"
                value-key="id"
                @change="handleChange"
                clearable
              >
                <el-option
                  v-for="p in partners"
                  :key="p.company.id"
                  :value="p"
                  :label="p.company.name"
                />
              </el-select>
            </el-form-item>
              <el-form-item
                label="Termék"
              >
                <el-select
                  v-model="product"
                  filterable
                  remote
                  :remote-method="searchProduct"
                  :loading="productLoading"
                  placeholder="Gépelj a kereséshez..."
                  style="width: 100%;"
                  value-key="id"
                  @change="handleChange"
                  clearable
                >
                  <el-option
                    v-for="p in products"
                    :key="p.id"
                    :value="p"
                    :label="p.name"
                  />
                </el-select>
              </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-row type="flex" justify="end"  style="text-align: right; margin-top: 24px;">
              <el-button
                :loading="downloadLoading"
                icon="el-icon-download"
                @click="download"
              >
                Letöltés
              </el-button>
              <el-button
                :loading="printLoading"
                icon="el-icon-printer"
                @click="print"
              >
                Nyomtatás
              </el-button>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div v-loading="loading">
      <el-table
        :data="data.data"
        style="width: 100%"
        row-key="id"
        border
      >
        <el-table-column
          prop="count"
          label="Teljesítés"
          width="100"
        >
          <template slot-scope="scope">
            {{ scope.row.completed_at }}
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          prop="count"
          label="Hiv. szám"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.reference_number }}
          </template>
        </el-table-column>

        <el-table-column
          prop="product_id"
          label="Cikksz."
          width="80"
        >
        </el-table-column>


        <el-table-column
          prop="product_name"
          label="Terméknév"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          prop="pack_type_name"
          label="Kisz."
          width="80"

        >
        </el-table-column>

        <el-table-column
          prop="count"
          label="Mennyiség"
          width="200"
        >
          <template slot-scope="scope">
            {{ scope.row.count }} {{ scope.row.pack_type_name }} ({{ scope.row.count *
            scope.row.count_per_pack }} db)
          </template>
        </el-table-column>


        <el-table-column
          prop="count_per_pack"
          label="db/kisz"
          width="80"
          align="right"
        >
        </el-table-column>

        <el-table-column
          prop="unit_price"
          label="Egységár"
          align="right"
        >
          <template slot-scope="scope">
            {{ scope.row.unit_price | currency }}
          </template>
        </el-table-column>

        <el-table-column
          prop="net_price"
          label="Nettó"
          align="right"
          width="150"
        >
          <template slot-scope="scope">
            {{ scope.row.net_price | currency }}
          </template>
        </el-table-column>

        <el-table-column
          prop="weight"
          label="Tömeg (db)"
          align="right"
        >
        </el-table-column>

        <el-table-column
          prop="sum_weight"
          label="Össz tömeg"
          align="right"
        >
        </el-table-column>

        <el-table-column
          prop="vat"
          label="Áfa"
          align="right"
          width="80"
        >
        </el-table-column>

        <el-table-column
          prop="is_stockist"
          label="Ár lemódosítva"
          width="130"
        >
        </el-table-column>

      </el-table>

      <div class="el-card-footer">
        <el-pagination
          background
          :current-page="currentPage"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="data.per_page"
          layout="total, prev, pager, next"
          :total="data.total"
          @current-change="handleCurrentChange"
        />
      </div>

    </div>
  </el-card>
</template>

<script>
  import moment from 'moment';
  import {saveAs} from 'file-saver';
  import {debounce} from 'debounce';


  export default {
    components: {},
    data() {
      const start = moment()
        .startOf('year')
        .format('Y-MM-DD');
      const end = moment()
        .format('Y-MM-DD');
      return {
        data: {},
        loading: false,
        downloadLoading: false,
        printLoading: false,
        partners: [],
        productName: '',
        products: [],
        product: null,
        supplier: null,
        partnerLoading: false,
        currentPage: 1,
        dateRange: [start, end],
        dateRangeOptions: {
          firstDayOfWeek: 1,
          shortcuts: [{
            text: 'Aktuális hét',
            onClick(picker) {
              const start = moment()
                .weekday(1)
                .toDate();
              const end = moment()
                .weekday(7)
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző hét',
            onClick(picker) {
              const start = moment()
                .subtract({weeks: 1})
                .weekday(1)
                .toDate();
              const end = moment()
                .subtract({weeks: 1})
                .weekday(7)
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Aktuális hónap',
            onClick(picker) {
              const start = moment()
                .startOf('month')
                .toDate();
              const end = moment()
                .endOf('month')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző hónap',
            onClick(picker) {
              const start = moment()
                .subtract({months: 1})
                .startOf('month')
                .toDate();
              const end = moment()
                .subtract({months: 1})
                .endOf('month')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző 3 hónap',
            onClick(picker) {
              const start = moment()
                .subtract({months: 3})
                .startOf('month')
                .toDate();
              const end = moment()
                .subtract({months: 1})
                .endOf('month')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Aktuális év',
            onClick(picker) {
              const start = moment()
                .startOf('year')
                .toDate();
              const end = moment()
                .endOf('year')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző év',
            onClick(picker) {
              const start = moment()
                .subtract({years: 1})
                .startOf('year')
                .toDate();
              const end = moment()
                .subtract({years: 1})
                .endOf('year')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'YTD',
            onClick(picker) {
              const start = moment()
                .startOf('year')
                .toDate();
              const end = moment()
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'MTD',
            onClick(picker) {
              const start = moment()
                .startOf('month')
                .toDate();
              const end = moment()
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      };
    },
    computed: {},
    watch: {},
    async mounted() {
      this.fetchData();
    },
    methods: {
      async download() {
        this.downloadLoading = true;
        try {
          const excel = await axios({
            url: `api/reports/inward-handling-items/download`,
            method: 'POST',
            responseType: 'blob',
            data: {
              from: this.dateRange[0],
              to: this.dateRange[1],
              supplier_id: this.supplier ? this.supplier.id : null,
              product_id: this.product ? this.product.id : null,
            },
          });
          saveAs(excel, `inwardhandlingitems.xlsx`);
        } catch (e) {
        }
        this.downloadLoading = false;
      },

      async print() {
        this.printLoading = true;
        const response = await axios.post('api/reports/inward-handling-items/print', {
          from: this.dateRange[0],
          to: this.dateRange[1],
          supplier_id: this.supplier ? this.supplier.id : null,
          product_id: this.product ? this.product.id : null,
        }, {
          responseType: 'arraybuffer',
          headers: {
            'Accept': 'application/pdf'
          },
        });
        this.printLoading = false;

        const newBlob = new Blob([response], {type: 'application/pdf'});
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }

        const data = window.URL.createObjectURL(newBlob);
        window.open(data);
      },

      async fetchData() {
        this.loading = true;
        let query = `api/reports/inward-handling-items?page=${this.currentPage}&from=${this.dateRange[0]}&to=${this.dateRange[1]}`

        if (this.supplier) {
          query += `&supplier_id=${this.supplier.id}`
        }

        if (this.product) {
          query += `&product_id=${this.product.id}`
        }

        this.data = await axios.get(query);
        this.loading = false;
      },

      async searchPartner(query) {
        if (query !== '') {
          this.partnerLoading = true;
          this.partners = await this.$store.dispatch('partner/search', '?name=' + query + '&type=supplier');
          this.partnerLoading = false;
        }
      },

      async searchProduct(query) {
        if (query !== '') {
          this.productLoading = true;
          this.products = await this.$store.dispatch('product/search', '?name=' + query);
          this.productLoading = false;
        }
      },

      debouncedSearch: debounce(function (e) {
        this.fetchData();
      }, 300),


      handleCurrentChange(val) {
        this.currentPage = val;
        this.fetchData();
      },

      handleChange() {
        this.currentPage = 1;
        this.fetchData();
      }
    },
  };
</script>
<style lang="scss">
  .stockValue-table {
    .el-table__footer {
      td {
        .cell {
          font-weight: 700;
        }
      }
    }
  }
</style>
